<template>
    <div class="operate-btns">
        <!-- <el-collapse v-model="activeName" accordion>
            <el-collapse-item
                v-for="(item, index) in taskNodes"
                :key="item.key"
                :name="item.key">
                <template slot="title" >
                    <div class="node-title">
                        {{item.label}}
                    </div>
                    <div class="form-item-option">
                        <i class="el-icon-delete" @click.stop="handleDeleteItem(index,item)" title="删除"></i>
                    </div>
                </template>
                <el-form size="mini"  style="height:100px;width:100%;overflow-y:auto" label-width="80px" class="node-props">
                    <el-form-item label="名称">
                        <el-input placeholder="请输入内容" v-model="item.label"></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-radio-group v-model="item.status" size="mini" class="operate-type" @change="onclick(index)">
                            <el-radio disabled :label="0" >未闭环</el-radio>
                            <el-radio disabled :label="1" >已闭环</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </el-collapse-item>
        </el-collapse> -->
         <el-button v-if="!isInstance" type="primary" icon="el-icon-circle-plus-outline" @click="handleNodeAdd" plain>添加闭环条件</el-button>
         <el-form size="mini"  style="margin-top:1%;height:310px;width:100%;overflow-y:auto" label-width="80px" class="node-props">
              <el-row 
                v-for="(item, index) in taskNodes"
                  :key="item.key"
                  :name="item.key"
                >
                  <el-col :span="12">
                      <el-form-item label="闭环条件">
                          <el-input :readonly="isRead && !(isInstance && ifConfig)" placeholder="请输入内容" v-model="item.label"></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="10">
                      <el-form-item label="状态">
                          <el-radio-group v-model="item.status" size="mini" class="operate-type" @change="onclick(index)">
                              <el-radio  :disabled="!(isInstance && ifConfig)" :label="0" >未闭环</el-radio>
                              <el-radio  :disabled="!(isInstance && ifConfig)" :label="1" >已闭环</el-radio>
                          </el-radio-group>
                      </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-button v-if="isInstance && ifConfig" type="danger" icon="el-icon-delete" title="删除" @click.stop="handleDeleteItem(index,item)" circle></el-button>
                  </el-col>
              </el-row>
          </el-form>
    </div>
</template>
<script>
    import { getUUID } from '@/utils/grocer';
    // eslint-disable-next-line standard/object-curly-even-spacing
    import { delProcessCloseTemplateTask, delProcessInstanceCloseTemplateTask} from '@/data-model';
    export default {
        data () {
            return {
                activeName: 1,
                statusName: ['未完成', '完成']
            };
        },
        props: {
            taskNodes: {
                type: Array,
                default: () => []
            },
            isInstance: {
                type: Boolean,
                default: false
            },
            ifConfig: {
                type: Boolean,
                default: false
            },
            isRead: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            'taskNodes' (newVal, oldVal) {
                this.editNode();
            }
        },
        created () {
        },
        methods: {
            handleNodeAdd () {
                this.taskNodes.push({
                    key: getUUID(16, 16),
                    id: '',
                    label: '',
                    status: 0,
                    remarks: ''
                });
            },
            async handleDeleteItem (index, item) {
                this.taskNodes.splice(index, 1);
                if (item !== null && item.id !== '') {
                    if (this.isInstance) {
                        await delProcessInstanceCloseTemplateTask(item.id);
                    } else {
                        await delProcessCloseTemplateTask(item.id);
                    }
                }
            },
            handleRadioChanges (val) {
                // console.log(val);
            },
            onclick (index) {
            },
            editNode () {
                this.$emit('editNode', this.taskNodes);
            }
        }
    };
</script>


<style lang="less">
    .operate-btns {
        display: flex;
        flex-direction: column;

        .el-collapse {
            border-left: 1px solid #ebeef5;
            border-right: 1px solid #ebeef5;
        }

        .node-title {
            padding: 0 0 0 10px;
            flex: 1;
        }

        .form-item-option {
            // position: absolute;
            width: 20px;
            right: 50px;
            cursor: pointer;
            display: block;
        }
        

        .node-list {
            display: flex;
            flex-direction: column;
        }
        .node-props {
            width: 100px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/process/CloseTemplate/CloseTemplateDetail/TaskNode.vue